<script>
    import Route, {router} from "../lib/Router/Router.svelte"
    import {APP_PATH} from "../lib/constants";
    import R, {LOADER} from "../lib/requests";
    import app from "../stores/app";
    import user from "../stores/user";
    import orders from "../stores/orders";
    import Alert from "../stores/alerts";
    import Notifier from "../stores/notifier";
    import {formatDate, copyObjectProperties, sort} from "../lib/lib";
    import PageHeader from "../components/PageHeader.svelte";
    import TableHeader from "../components/TableHeader.svelte";
    import AppIcon from "../components/icons/AppIcon.svelte";
    import ClientEditModal from "./ClientEditModal.svelte";
    import Pagination from "../components/Pagination.svelte";


    let clients = null;
    let total = 0;
    let page = 1;
    let selectedId = 0;
    let editId = null;
    let search = {
        limit: 50,
        offset: 0,
        code: null,
        term: null,
    }

    const pageHeaderControls = [
        {id: 'create', name: 'ΔΗΜΙΟΥΡΓΙΑ ΠΕΛΑΤΗ', class: 'hidden-xs'},
        {id: 'create', name: '', icon: 'plus-circle', class: 'hidden-xl hidden-lg hidden-md hidden-sm'},
        {id: 'reload', name: '', icon: 'refresh'}
    ];

    const tableColumns = [
        {key: 'code', title: 'ΚΩΔΙΚΟΣ', sortable: true},
        {key: 'company', title: 'ΕΠΙΧΕΙΡΗΣΗ', sortable: true, sort_way: 'ASC'},
        {key: 'name', title: 'ΟΝΟΜΑ', sortable: true},
        {key: 'phone', title: 'ΤΗΛΕΦΩΝΟ', sortable: true, class: 'hidden-xs'},
        {key: 'email', title: 'EMAIL', sortable: true, class: 'hidden-xs'},
        {key: 'cloud_key', title: 'C', sortable: true, class: 'hidden-xs'},
        {key: '', title: ''},
        {key: '', title: '', hidden: !user.isAdmin()},
    ];

    const load = () => {
        const onSuccess = result => {
            clients = result.clients;
            total = result.total;
        }

        const onFailure = err => {
        };

        search.offset = (page - 1) * search.limit;

        R.handle(R.client.index, search, onSuccess, onFailure, LOADER.PAGE);
    }

    const onSearch = () => {
        page = 1;
        load();
    }

    const onSearchChange = () => {
        page = 1;
        load();
    }

    const clearSearch = () => {
        search.code = null;
        search.term = null;
        page = 1;
        load();
    }

    const onColumnSort = ({detail}) => {
        search.sort_field = detail.key;
        search.sort_way = detail.sort_way;
        load();
    }

    const onPageChange = ({detail}) => {
        page = detail;
        load();
    }

    const onCreate = () => {
        editId = 0;
    }

    const onEdit = (client) => {
        selectedId = client.id;
        editId = client.id;
    }

    const closeEdit = (client) => {
        if (client) {
            let properties = ['id', 'code', 'name', 'phone', 'email', 'cloud_key'];

            let item = clients.find(x => x.id == client.id);
            if (item) {
                copyObjectProperties(client, item, properties);
                clients = clients;
            } else {
                clients = [copyObjectProperties(client, properties), ...clients];
            }
        }
        editId = null;
    }

    const onDelete = (client) => {
        Alert.delete("Διαγραφή πελάτη", `Πρόκειται να διαγράψετε τον πελάτη "${client.name}" και όλες τις εντολές του.\nΘέλετε να συνεχίσετε;`, () => deleteClient(client.id));
    }

    const deleteClient = id => {
        const onSuccess = result => {
            clients = clients.filter(x => x.id != result);
            Notifier.showMessage("Ο πελάτης διαγράφτηκε");
        }

        const onFailure = err => {

        };

        R.handle(R.client.delete, id, onSuccess, onFailure, LOADER.POPUP);
    }

    const onClientOrders = (client) => {
        $orders.list = null;
        router.go(`/${APP_PATH}/orders?client_id=${client.id}`)();
    }

    load();
</script>

<PageHeader title="Πελάτες" controls={ pageHeaderControls } on:create={ onCreate } on:reload={ load }/>
<div class="panel panel-simple p-2 mb-5">
    <div class="row">
        <div class="col-xl-1 col-lg-2 col-md-2 form-group-sm">
            <input type="text" class="form-control" bind:value="{ search.code }" on:change={ onSearch }
                   placeholder="κωδικός">
        </div>
        <div class="col-xl-9 col-lg-6 col-md-4 form-group-sm">
            <input type="text" class="form-control" bind:value="{ search.term }" on:change={ onSearch }
                   placeholder="πελάτης">
        </div>
        <div class="col-xl-1 col-lg-2 col-md-3 col-6">
            <button class="btn btn-default btn-block" on:click={ clearSearch }>ΚΑΘΑΡΙΣΜΟΣ</button>
        </div>
        <div class="col-xl-1 col-lg-2 col-md-3 col-6">
            <button class="btn btn-outline btn-block" on:click={ onSearch }>ΕΥΡΕΣΗ</button>
        </div>
    </div>
</div>
{#if clients}
    {#if clients.length}
        <table class="table table-list clients-list table-list-border mb-4">
            <TableHeader {tableColumns} on:sort={ onColumnSort }/>
            <tbody>
            {#each clients as item}
                <tr class="row-hover" class:row-selected="{ selectedId === item.id }">
                    <td class="code">
                        { item.code }
                    </td>
                    <td>
                        <span class="is-link" class:not-active="{ item.is_active < 1 }"
                              on:click="{ () => onEdit(item) }">
                            { item.company }
                        </span>
                    </td>
                    <td class="text-gray">
                        { item.name }
                    </td>
                    <td class="text-gray hidden-xs">
                        { item.phone }
                    </td>
                    <td class="text-gray hidden-xs">
                        { item.email }
                    </td>
                    <td class="button-column">
                        {#if item.cloud_key}
                            <a href="{ $app.cloud_url + "/" + item.cloud_key }" title="Cloud πελάτη" target="_blank">
                                <AppIcon icon="cloud" size="16"/>
                            </a>
                        {/if}
                    </td>
                    <td class="button-column pointer" title="εντολές πελάτη"
                        on:click="{ () => onClientOrders(item) }">
                        <AppIcon icon="orders" size="16"/>
                    </td>
                    {#if user.isAdmin()}
                        <td class="button-column pointer" title="διαγραφή πελάτη"
                            on:click="{ () => onDelete(item) }">
                            <AppIcon icon="trash" size="16"/>
                        </td>
                    {/if}
                </tr>
            {/each}
            </tbody>
        </table>
        <Pagination itemsPerPage="{ search.limit }" totalItems="{ total }" { page }
                    on:change="{ onPageChange }"/>
    {/if}
{/if}
{#if editId != null}
    <ClientEditModal clientId="{ editId }" closeCallback="{ closeEdit }"/>
{/if}

<style>
    .clients-list .code {
        width: 60px;
    }
</style>